import {
  IconNameEnum,
  useDisruptionStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { CoreDisruptionComponent } from "@b2bportal/core-types";
import { Icon } from "@b2bportal/core-ui";
import type { DisruptionExerciseHeaderProps } from "./DisruptionExerciseHeader";
import defaultStyles from "./DisruptionExerciseHeader.module.scss";

export const DisruptionExerciseHeaderMobile = (
  props: DisruptionExerciseHeaderProps
) => {
  const COMPONENT_KEY = CoreDisruptionComponent.DisruptionExerciseHeader;
  const styles = useDisruptionStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <div className={cn("disruptionExerciseHeaderContainerMobile")}>
      <div className={cn("contentMobile")}>
        <div className={cn("navComponentContainer")}>
          <Icon
            iconName={IconNameEnum.backIcon}
            onClick={props.onBack}
            className={cn("backIcon")}
          />
        </div>
        <div className={cn("mobileTitleSubtitleContainer")}>
          <span className={cn("titleMobile")}>{props.title}</span>
        </div>
        <div className={cn("navComponentContainer")}>
          {props.rightNavElement ? props.rightNavElement : <div></div>}
        </div>
      </div>
      <hr></hr>
    </div>
  );
};
